import { Component, EventEmitter, Output, Input, OnInit, ViewChild, NgZone, HostListener } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { LoginComponent } from '../../../esscalo_funcionalidad/src/login/login.component';
// import { CarInformationComponent } from '../../../mc_funcionalidad/src/app/car_information/car_information.component';
 // import * as config './config.json';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';

import { DataLogin } from '../../../esscalo_funcionalidad/src/login/DataLogin'; //
import { urls } from '../../../esscalo_funcionalidad/src/config/urls';
import { configuration } from '../config/config';

import { saveAs } from 'file-saver';

import * as $ from 'jquery';
import { unescapeIdentifier } from '@angular/compiler';

declare const Buffer;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [LoginComponent, urls, configuration]
})
export class AppComponent implements OnInit{

    private _selected_type: string;

    login_title = '';
    img_logo = '../../assets/images/Logo_Esscalo.png';
    name_admin_button = 'Administrador';
    mbxUser     = '';
    mbxPass     = '';
    headers;
    data        = { token: '' };
    car_info;

    choose_car_selection = 1;

    step_0 = false;
    step_1 = false;
    step_2 = false;
    step_3 = false;

    // requirements = {
    //   carga: false,
    //   autos: false
    // }

    load_selected = null;
    quote_selected = null;

    user_info;

    // 1er FORMULARIO (AUTO)
    car_types  = [];
    car_brands = [];
    car_years  = [];
    car_models = [];
    cols_data;
    cities_data = [];

    // 2do FORMULARIO (INFO GENERAL)
    info_states     = [];

    // 1er FORMULARIO (AUTO)
    selected_type_ = '';
    selected_brand_ = '';

    zip_code;
    state;
    city;
    id_state;
    gen_info;
    contact_info;
    // insurance_data;
    params_quote;
    admin_full;

    total_progress;
    progress = 0;
    progress_percent;
    percent_item;
    services_;
    form_data_id;
    insurance_data = [];
    insurance_count = 0;
    insurance_length;
    loader;

    url_quotes;
    quotes_datasource;
    status_emit;
    pagination;
    users_admins;
    lists_agencias;
    all_agencias: any;
    lists_aseguradora;

    location;

    comments_quote;
    comment_added;
    data_new_cars;

    data_new_car;
    new_quote;

    emision_data;
    result_carga_list;
    result_update_quote;
    result_report;
    result_report_client;
    get_certificates_download;
    result_factura;
    result_comision;

    // carga
    contractors_datasource;
    contractor_added;
    response_quote;
    exchange_rite;
    group_list;
    headers_login;
    headers_xls_export;

    client_group;
    insured_selected;
    insured_list;
    country_list;
    containers_list;
    commodity_list;
    coverages_list;
    specify_rates_list;
    all_asegurados_data;

    // notificaciones
    form: FormGroup;

    types = ['alert', 'error', 'info', 'warn', 'success'];
    animationTypes = ['fromRight', 'fromLeft', 'scale', 'rotate'];

    result_rate_exchange = [];

    result_certificate = [];
    result_emission = [];

    requirements = {
      autos: true
    }

    client_info;

    admin;
    show_form_client;
    return_to_;
    services;

    insurances_by_user;

    responsive = false;
    data_emitir;

    nombreCliente = '';

    // Señal para indicar el spinner de descarga de excel del listado de cotizaciones
    signal = false;

    @HostListener('window:resize') onResize() {

      if(window.innerWidth <= 999) {
        this.responsive = true;
      } else if(window.innerWidth >= 1000) {
        this.responsive = false;
      }
    }

    constructor(
     private http: HttpClient,
     private url: urls,
     private config: configuration,
     private _notifications: NotificationsService,
     // private save_as : saveAs,
     private _fb: FormBuilder,
     private zone: NgZone) {

     // CONFIGURACION
     sessionStorage['config'] = JSON.stringify(this.config);

      this.config = config;

     if(window.innerWidth <= 999) {
       this.responsive = true;
     } else if(window.innerWidth >= 1000) {
       this.responsive = false;
     }
   }

    ngOnInit() {
      // realizamos el logout al cargar el componente porque ya no deberian de poder ingresar a la aplicacion
      this.logOut();

      // establecer el nombre del cliente si es cliente al cargar el componente
      if (localStorage.getItem('client_group')) {
        let clientGroup = JSON.parse(localStorage.getItem('client_group'));
        this.nombreCliente = clientGroup.contratantes_info[0].nombre;
      }

      this.form = this._fb.group({
        type: 'success',
        title: 'This is just a title',
        content: 'This is just some content',
        timeOut: 5000,
        showProgressBar: false,
        pauseOnHover: true,
        clickToClose: true,
        animate: 'scale'
      });

      localStorage['requirements'] = JSON.stringify(this.requirements);

      this.admin = false;

     if(sessionStorage['token']) {
       this.data.token = sessionStorage['token'];
       this.headers = new HttpHeaders().set('Authorization','Token '+ sessionStorage['token']);
       this.headers_xls_export = new HttpHeaders()
           .set('Authorization','Token '+ sessionStorage['token'])
           // .set('Content-Type' ,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

       this.getCarTypes();
     } else {
       this.logOut();
     }

     if(localStorage['car_info']) {
       this.car_info = JSON.parse(localStorage['car_info']);
       this.get_states();
     }

     if(localStorage['general_info']) {
       this.gen_info = JSON.parse(localStorage['general_info']);
     }

     if(localStorage['contact_info']) {
       this.contact_info = JSON.parse(localStorage['contact_info']);
     }

     if(localStorage['admin']) {
       this.admin = true;
     } else {
       this.admin = false;
     }
     if(localStorage['admin_full']) {
      this.admin_full = true;
    } else {
      this.admin_full = false;
    }
     if(localStorage.client_group) {
       this.client_group = JSON.parse(localStorage.client_group);
     }

     if(localStorage.insured_selected) {
       this.insured_selected = JSON.parse(localStorage.insured_selected);
     }

     if(sessionStorage['user_info']) {
       this.user_info = JSON.parse(sessionStorage['user_info']);

     } else {
       this.user_info = {
         first_name : ''
       };
     }

console.log(localStorage['location'])
     if(localStorage['location']) {

       // console.log(localStorage.location);
       switch (localStorage['location']) {
         case 'step_0':
           this.change_step('0');
           this.location = localStorage['location'];
           break;
         case 'step_1':
           // this.change_step('1');
           this.location = localStorage['location'];

           // this.choose_location(1);
           break;
         case 'step_2':
           this.change_step('2');
           this.location = localStorage['location'];
           this.choose_location(1);
           break;
         case 'step_3':
           this.change_step('3');
           this.location = localStorage['location'];
           this.choose_location(1);
           break;
         case 'compare':
           this.location = localStorage['location'];
           this.choose_location(1);
           break;
         case 'quote_detail':
           this.location = localStorage['location'];
           this.choose_location(1);
           break;
          case 'login_admin':
           this.location = localStorage['location'];
           this.goAdmin();
           break;
          case 'admin_list':
           this.location = localStorage['location'];
           this.choose_location(2);
           this.getQuoteList(null);
           break;
          case 'mc_1':
           this.location = localStorage['location'];
           this.choose_location(1);
           // this.getQuoteList(null);
           break;
         default:
           // code...
           this.location = localStorage['location'];
           break;
       }
     }
      this.get_coverages();
    };


   goHome() {
     this.change_step('0');
   }

  onLogin(credentials: string):void {

    this.admin = false;

    let _credentials = JSON.parse(credentials);
    let url_esscalo;
    let params = new HttpParams();

    if(_credentials.user_type == '2') {
      url_esscalo = this.url.login;
    } else {
      url_esscalo = this.url.login_local;
    }


    params = new HttpParams({
      fromObject: {
        username : _credentials.username,
        password : _credentials.password,
        urlname : this.config.urlname,
        org : this.config.org
      }
    });


    this.http
    .post(url_esscalo, params, { headers: this.headers_login })
    .subscribe((res: any) => {

      this.mbxUser = '';
      this.mbxPass = '';
      if(_credentials.username == 'superuser_esscalo' || _credentials.username == 'angy' || _credentials.username == 'Esscalo_Seguros') {
        localStorage.superuser = 1;
      } else {
        localStorage.superuser = 0;
      }

      if(res.is_superuser){
        localStorage.admin_full = 'true';
        this.admin_full = true;
      } else {
        localStorage.admin_full = 'false';
        this.admin_full = false;
      }

      sessionStorage['user_info'] = JSON.stringify(res);
      this.user_info = JSON.parse(sessionStorage['user_info']);
      sessionStorage['token'] = res.token;
      this.getCarTypes();
      // console.log('token', sessionStorage['token']);
      // sessionStorage.config = JSON.stringify(config);

      this.headers = new HttpHeaders().set('Authorization','Token '+ sessionStorage['token']);

      this.headers_login = new HttpHeaders()
                            .set('Content-Type', 'application/x-www-form-urlencoded')
                            .set('Accept', 'application/x-www-form-urlencoded');

      this.data = res;

      if(_credentials.user_type == '1') {

        this.http
        .get(this.url.get_groups,
          { params: { urlname : this.config.urlname},
            headers: this.headers })
        .subscribe((res: any) => {
          console.log('client_group', res);
          this.client_group = res.results[0];
          localStorage.client_group = JSON.stringify(res.results[0]);

          // establecer el nombre del cliente al realizar login
          this.nombreCliente = res.results[0].name;
        });

      } else if(_credentials.user_type == '2') {
        url_esscalo = this.url.login;
        localStorage.admin = 'true';
        this.admin = true;
        this.nombreCliente = '';
      } else {
        url_esscalo = this.url.login_local;
        this.nombreCliente = ''
      }

      // console.log(localStorage.location);
      if(localStorage['location'] == 'login_admin') {
        localStorage['location'] = 'admin_list';
        this.location = 'admin_list';
        this.getQuoteList(null);

      } else {
        // normal login
        // console.log('normal', this.location);
        // this.change_step('1');
        this.location = 'step_1';
        localStorage['location'] = 'step_1';

        // this.getCarTypes();
      }

    }, (error) => {
      console.log(error);
      if(error.error.error  == "User inactive") {
          this.create('error', 'Error', 'Usuario desactivado, favor de revisar con su administrador.');
      } else{
          this.create('error', 'Error', 'El usuario o contraseña es incorrecto, intente nuevamente.');
      }

      if(error.error) {
        this.mbxUser = '';
        this.mbxPass = '';
        // alert(error.error.error);
        // this.data = JSON.stringify(error.error.error);
        // this.data.emit(JSON.stringify(error.error.error));
      }
    });
  }

  delete_register(params: any) {

    // sweetAlert
    // alert('¿Esta seguro de eliminar el registro?');

    // console.log('aaa', params);


    if(params.type == "client") {
      this.http
      .post(this.url.delete_group,{id: params.id}, {headers: this.headers})
      .subscribe((res:any) => {
        console.log('delete group - res', res);
        this.search_contractor('');
        this.create('success', 'Cliente eliminado','Los usuarios relacionados a éste cliente han sido eliminados.');

      });
    }else if(params.type == "admin") {
      this.http
      .delete(params.url.replace('users', 'users-admin')+'?urlname='+this.config.urlname, {headers: this.headers})
      .subscribe((res:any) => {
        console.log('delete user', res);
        this.search_contractor('');
        this.create('success', 'Usuario eliminado','El usuario admin ha sido eliminado');
        this.get_admins('');

      });
    }else {

      this.http
      .delete(params.url+'?urlname='+this.config.urlname, {headers: this.headers})
      .subscribe((res: any) => {

        if(params.type == "users") {
          this.create('success', 'Usuario eliminado','');
          let client_ = { id: params.client };
          this.contractors_by_grouo(client_);
        } else if(params.type == "client") {
          this.search_contractor('');
          this.create('success', 'Cliente eliminado','');

        }
      });
    }


  }

  delete_client(params: any) {

  }

  changes_user;

  patch_datasource(params: any):void {
    // console.log('params', params);
    params.urlname = this.config.urlname;

    let datasource = {
        first_name: params.first_name,
        last_name: params.last_name,
        email: params.email
    }

    if(params.password) {
      datasource['password'] = params.password;
    }

    this.http
    .patch(params.url+'?urlname='+this.config.urlname,
      datasource,
      { headers: this.headers }
      )
    .subscribe((res: any) => {

      this.create('success', null,'El cambio se ha realizado con éxito.');

      if(params.type == 'users') {
        this.changes_user = res;
      }

    });
  }

  chooseOption(param) {
    if(param == 1) {
      // carga
      this.location = 'step_1';
      localStorage['location'] = 'step_1';

    } else if(param == 2) {
      // autos
      this.location = 'mc_1';
      localStorage['location'] = 'mc_1';
    }
  }

  goAdmin(): void {

    if(localStorage['location'] == 'login_admin') {

      this.login_title       = 'Iniciar sesión';
      this.name_admin_button = 'Administrador';
      this.location          = '';
      this.logOut();

    } else {

      localStorage['location']  = 'login_admin';
      this.location          = 'login_admin';
      this.login_title       = 'Iniciar sesión como administrador';
      this.name_admin_button = 'Salir';
    }

    // console.log('location', this.location);
  }

  logOut() {

    sessionStorage.removeItem('token');
    this.location = '';
    this.contractors_datasource = [];
    // this.data.token = null;
    this.data = { token: '' };
    this.change_step('');
    // this.user_info = null;
    // console.log('data', this.data);
    localStorage.clear();
    // sessionStorage.clear();
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user_info');
    // this.user_info.first_name = '';
    // this.user_info.last_name = '';
    localStorage['requirements'] = JSON.stringify(this.requirements);

  };

  users_datasource;
  contractors_by_grouo(params: any):void {
    this.http
    .get(this.url.user_by_group, {
      params: {
        group: params.id,
        urlname: this.config.urlname
      },
      headers : this.headers
    })
    .subscribe((res: any) => {
      this.users_datasource = res;
      this.pagination = null;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };
    });
  };

  // pagination;

  paid_out(param){
    this.http
      .get(this.url.paid_quote , {
        params: {
          id_quote: param
        },
        headers: this.headers

      })
      .subscribe((res: any) => {


      });

  }

  delete_quote(param){
    this.http
      .get(this.url.delete_carga_quote , {
        params: {
          id_quote: param
        },
        headers: this.headers

      })
      .subscribe((res: any) => {


      });
  }

  search_contractor(param) {
    if(param['url']) {
      this.http
      .get(param.url, {

        headers: this.headers

      })
      .subscribe((res: any) => {
        this.contractors_datasource = res.results;

          this.pagination = null;
          this.pagination = {
            count : res.count,
            next  : res.next,
            previous : res.previous
          };

      });
    }else if(param['all']) {
      this.http
      .get(this.url.all_group,{
        params: { cadena: param.cadena ? param.cadena : '' },
        headers: this.headers

      })
      .subscribe((res: any) => {
        this.contractors_datasource = res;

          this.pagination = null;
          this.pagination = {
            count : res.count,
            next  : res.next,
            previous : res.previous
          };

      });
    }else {
      this.http
      .get(this.url.grupo_filter, {
        params: {
          cadena: param['cadena'] ? param['cadena'] : param
        },
        headers: this.headers

      })
      .subscribe((res: any) => {
        this.contractors_datasource = res.results;

        if(!param['autocomplete']) {

          this.pagination = null;
          this.pagination = {
            count : res.count,
            next  : res.next,
            previous : res.previous
          };
        }

      });
    }


  }

  search_contractor_user(param) {
    console.log(param.url)
    if(param['url']) {
      this.http
      .get(param.url, {

        headers: this.headers

      })
      .subscribe((res: any) => {
        this.users_datasource = res;

          this.pagination = null;
          this.pagination = {
            count : res.count,
            next  : res.next,
            previous : res.previous
          };

      });
    } else {
      this.http
      .get(this.url.user_by_group, {
        params: {
          group: param.id,
          urlname: this.config.urlname
        },
        headers : this.headers
      })
      .subscribe((res: any) => {
        this.users_datasource = res;
        this.pagination = null;
        this.pagination = {
          count : res.count,
          next  : res.next,
          previous : res.previous
        };
      });
    }
  }

  get_admins(param) {
    let url = this.url.users;
    if(param != '' && param != null && param != undefined) {
      url = param;
    }
    this.http.get(url, {headers: this.headers}).subscribe((res: any) => {
      this.users_admins = res.results;
      this.pagination = null;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };
    });
  }
  
  get_agencias(param) {
    var url = this.url.agencias
    if (param != null && param != undefined){
        url = param
    }
    this.http.get(url, {headers: this.headers}).subscribe((res: any) => {
      this.lists_agencias = res.results;
      //console.log("lists_agencias", this.lists_agencias)

          this.pagination = null;
          this.pagination = {
            count : res.count,
            next  : res.next,
            previous : res.previous
          };

      });

      // Todas las agencias

      // Variable para obtener la url de todas las agencias
      let url_all_agencias = this.url.all_agencias

      // Obtener todas las agencias y guardarlas en la variable all_agencias
      this.http.get(url_all_agencias, {headers: this.headers}).subscribe((res: any) => {
        this.all_agencias = res.results;
        });
  };

  new_agencia;
  save_agencias(params: any):void {
  //console.log(params)

    params.urlname = this.config.urlname;
    if (params.url==undefined || params.url==undefined ){
      this.http
      .post(this.url.agencias, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        this.create('success', 'Agencia creada con éxito.', null);
        this.new_agencia = res;
        this.get_agencias('');

      }, ({error}) => {
         this.create('error', error.error , null);
      });
    } else if (params.url){
      this.http
      .patch(params.url.replace('users', 'users-admin')+'?urlname='+this.config.urlname, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        this.create('success', 'Agencia actualizado', null);
        this.new_agencia = res;
        this.get_agencias('');

      }, (error) => {
        let error_message = '';
        for (let key in error.error){
          error_message += error.error[key][0]
          }
        console.log('error', error_message);
         this.create('error', error_message, null);
      });
    }
  }

  get_aseguradora(param) {
    var url = this.url.aseguradora
    if (param != null && param != undefined){
        url = param
    }
    this.http.get(url, {headers: this.headers}).subscribe((res: any) => {
      this.lists_aseguradora = res.results;
      //console.log("lists_aseguradora", this.lists_aseguradora)
          this.pagination = null;
          this.pagination = {
            count : res.count,
            next  : res.next,
            previous : res.previous
          };

      });
  };

  new_aseguradora;
  save_aseguradora(params: any):void {
    // console.log(params)
    params.urlname = this.config.urlname;
    if (params.url==undefined || params.url==undefined ){
      this.http
      .post(this.url.aseguradora, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        this.create('success', 'Aseguradora creada con éxito.', null);
        this.new_aseguradora = res;
        this.get_aseguradora(null);

      }, ({error}) => {
         this.create('error', error.error , null);
      });
    } else if (params.url){
      this.http
      .patch(params.url+'?urlname='+this.config.urlname, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        this.create('success', 'Aseguradora actualizado', null);
        this.new_aseguradora = res;
        this.get_aseguradora(null);

      }, (error) => {
        let error_message = '';
        for (let key in error.error){
          error_message += error.error[key][0]
          }
        console.log('error', error_message);
         this.create('error', error_message, null);
      });
    }
  }

  choose_location(param) {

    this.choose_car_selection = param;

    if(param == 1) {
      this.location = 'mc_1';
      localStorage['location'] = 'mc_1';
      localStorage.removeItem('selected_quote');
    } else if(param == 2) {
      this.location = 'admin_list';
      localStorage['location'] = 'admin_list';
      this.getQuoteList(null);
    }

  }

  change_location(param) {
    console.log('-patera',param)
    if(param == 'esc_admin') {
      this.get_quotes_data();
    }

    let new_location = param;

    this.location = new_location;
    localStorage.location = new_location;

  }

  duplicate_quote(){
    let new_location = 'step_1';

    this.location = new_location;
    localStorage.location = new_location;
  }



// STEPS

  change_step(parStep) {
    // console.log('parStep', parStep);
    switch (parStep) {
      case '0':
        this.step_0 = true;
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = false;
        localStorage['location'] = 'step_0';
        this.location = localStorage['location'];
        break;
      case '1':
        this.step_1 = true;
        this.step_2 = false;
        this.step_3 = false;
        // localStorage['location'] = 'step_1';
        // this.location = localStorage['location'];
        localStorage['location'] = 'mc_1';
        this.location = localStorage['location'];
        break;
      case '2':
        this.step_1 = false;
        this.step_2 = true;
        this.step_3 = false;
        localStorage['location'] = 'step_2';
        this.location = localStorage['location'];
        break;
      case '3':
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = true;
        localStorage['location'] = 'step_3';
        this.location = localStorage['location'];
        break;
      default:
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = false;
        this.location = '';
        break;
    }
  }

  returnToList() {
    this.load_selected = null;
    this.quote_selected = null;
  };

  return_it(param) {
     // console.log('location', this.location);

     if(param) {
        localStorage['location'] = 'mc_1';
         this.location = 'mc_1';
     }

     if(this.location == 'step_0') {
       // localStorage.clear();
       // sessionStorage.removeItem('token');
       // this.location = null;
       // console.log('location', this.location);
       // console.log('aaaaaaaaaaaaaaaaaaaa');
       this.home();
     } else if(this.location == 'mc_1') {
       localStorage['location'] = 'step_0';
       this.location = 'step_0';
     } else if(this.location == 'step_2') {
       this.location = 'mc_1';
       // localStorage.removeItem('car_info');
     } else if(this.location == 'step_3') {
       this.location = 'step_2';
     }
  };

  home() {
     localStorage.clear();
     this.location = null;
     sessionStorage.removeItem('token');
  };

  create(parType, parTitle, parContent) {

    // console.log('FORM', this.form);
    // console.log(this.form.getRawValue());


    const temp = this.form.getRawValue();
    // console.log('temp', temp);

    const title = parTitle;
    const content = parContent;
    const type = parType;
    // console.log('-------------', this._notifications);

    this._notifications.create(title, content, type, { timeOut: 3000 });

    // console.log('aksljdfkjd');

    // const toast = this._notifications.success('Item created!', 'Click to undo...', {
    //   timeOut: 5000,
    //   showProgressBar: false,
    //   pauseOnHover: true,
    //   clickToClose: true,
    //   clickIconToClose: true
    // });

    // console.log('aaaaa', toast);

  };

  return_menu():void {
    localStorage['location'] = 'step_0';
    this.location = 'step_0';
    this.change_step('0');
  }

// carga
  carga_export(params: any):void {

    // Señal para el spinner de carga
    this.signal = true;
    let fechaExportacion = new Date();

    this.http
    .get(this.url.report_carga_quotes_v2, {
      params: params,
      headers: {'Authorization': 'Token ' + sessionStorage['token'],
                'Content-Type': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},
      responseType : 'arraybuffer'
    })
    .subscribe((res: any) => {
      let resultadoFecha = (new Date().getTime() - fechaExportacion.getTime());

      // Verificar si al momento de exportar los datos tarda menos de 1 segundo
      if (resultadoFecha < 1000) {
        // Esperar al menos 1 segundo para realizar la descarga
        setTimeout(() => {
          let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          saveAs(blob, 'Reporte-'+(Math.random() + 1).toString(36).substring(7)+'.xls');
          this.quotes_datasource = res.results;
          this.result_report = res.results;

          this.create('success', 'Reporte', 'Reporte descargado con éxito.');

        }, (1000 - resultadoFecha));

      } else {
        let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, 'Reporte-'+(Math.random() + 1).toString(36).substring(7)+'.xls');
        this.quotes_datasource = res.results;
        this.result_report = res.results;

        this.create('success', 'Reporte', 'Reporte descargado con éxito.');

      }

    },
    (err: any) => {
      // Enviar señal del spinner si ocurrió un error
      this.signal = false;

      // Enviar mensaje de error a la consola y mostrar SweetAlert
      console.error('Ah ocurrido un error al generar el reporte de Excel: ', err.name);
      console.error('Mensaje de error: ', err.message);

      this.create('error', 'Reporte', 'Ha ocurrido un error al generar el reporte: ' + err.name);

    },
    () => {
      // Ejecutar al final de la suscripción
      let resultadoFecha = (new Date().getTime() - fechaExportacion.getTime());

      // Enviar la señal del spinner en un segundo si ocurre en menos de este
      if (resultadoFecha < 1000) {
        setTimeout(() => {
          this.signal = false;

        }, (1000 - resultadoFecha));

      } else {
        this.signal = false;

      }
    });

  }

export_cert(params: any):void{
    this.create('info', 'Solicitud enviada', null);

    this.http
    .post(this.url.download_certificates,params, {
      params: params,
      headers: {'Authorization': 'Token ' + sessionStorage['token'],
                'Content-Type': "application/json"},
      responseType : 'arraybuffer'
    })
    .subscribe((res: any) => {
      if(!res){
        this.create('error', 'Error al generar el archivo', null);
        return
      }
      let blob = new Blob([res], {type: "application/zip"});
      saveAs(blob, 'Certificados-'+(Math.random() + 1).toString(36).substring(7)+'.zip');
      this.get_certificates_download = res.results;
      this.quotes_datasource = res.results;

      this.create('success', 'Archivo Generado de manera exitosa', null);

    }, (error) => {
      if (error.status && error.status==404){
        this.create('warn', 'No se encontraron certificados', null);
      } else {
        this.create('error', 'Ocurrio un error al exportar cerificados', null);

      }

    });

}


  get_quotes_data() {

    this.http
    .get(this.url.carga_quote, {headers: this.headers})
    .subscribe((res: any) => {
      this.quotes_datasource = res.results;

      this.pagination = null;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };
    });

  }

// ------------------------ INICIAN LLAMADAS PARA / mbx-car-info     --------------------------------------------
  getCarTypes():void {

    // console.log('getCarTypes');

    this.car_types = [];
    // this.headers = new HttpHeaders().set('Authorization','Token '+ sessionStorage.token);

    this.http
    .get(this.url.car_types)
    .subscribe((res: any) => {
      for(let i in res) {
        this.car_types.push({
          name : res[i]
        });

      }
    }, (error) => {
      console.log(error);
      if(error.error) {

        // alert(error.error.error);
        // this.data = JSON.stringify(error.error.error);
        // this.data.emit(JSON.stringify(error.error.error));
      }
    });
  };

  car_marc(selectedType: string): void {

    this.selected_type_ = selectedType;

    this.http
    .get(this.url.car_brands+selectedType)
    .subscribe((res: any) => {
      this.car_brands = res;
    }, (error) => {
      console.log(error);
    });
  };

  car_year(selectedBrand: string): void {

    this.selected_brand_ = selectedBrand;

    this.http
    .get(this.url.car_years+this.selected_type_ + '/' + selectedBrand)
    .subscribe((res: any) => {
      let years = res.reverse();

      this.car_years = years;
    }, (error) => {
      console.log(error);
    });
  };

  car_model(selectedYear: string): void {

    this.http
    .get(this.url.car_models+this.selected_type_ + '/' + this.selected_brand_ + '/' + selectedYear)
    .subscribe((res: any) => {
      // console.log('models', res);
      let models = [];
      for(var item in res) {
        res[item].forEach(function(i) {
          models.push(i);
        });
      }

      this.car_models = models;

    }, (error) => {
      console.log(error);
    });
  };

  carInfoFinish(carInfo: string): void {
    this.car_info = JSON.parse(carInfo);
    localStorage['car_info'] = carInfo;
    this.get_states();
    this.change_step('2');
    this.location ="step_2"
  };

  data_desde;
  data_hasta;

  cols_by_zip(params: any): void {
    this.http
    .get(this.url.get_cols_by_zip+params.zipCode, {headers: this.headers})
    .subscribe((res: any) => {
      if(params.type == 1) {
        this.data_desde = res;
      } else {
        this.data_hasta = res;
      }
      // this.cols_data = res;
    }, (error) => {
      this.create('error', 'Error', 'Ingrese un código postal valido.');
    });
  }

// ------------------------ INICIAN LLAMADAS PARA / mbx-general-info --------------------------------------------

  get_states():void {

    // console.log('get-states - HEADERS', this.headers);

    this.http
    .get(this.url.get_states, {headers: this.headers})
    .subscribe((res: any) => {
      this.info_states = res.states;
    }, (error) => {
      if(error.error) {
      }
    });
  };

  get_cites(idState: string): void {
    this.id_state = idState;
    this.http
    .get(this.url.get_cities+idState, {headers: this.headers})
    .subscribe((res: any) => {
      this.cities_data = res;
    }, (error) => {
      if(error.error) {
      }
    });
  };

  get_cols_by_city (selectedCity: string): void {

    selectedCity = selectedCity.replace(/ /g, '_');
    this.city = selectedCity;

    this.http
    .get(this.url.get_cols_by_city+this.id_state+'/'+selectedCity, {headers: this.headers})
    .subscribe((res: any) => {
      this.cols_data = res;
    }, (error) => {
      if(error.error) {
      }
    });
  };

  get_cols_by_zip(zipCode: string): void {

    this.http
    .get(this.url.get_cols_by_zip+zipCode, {headers: this.headers})
    .subscribe((res: any) => {
      this.cols_data = res;
    }, (error) => {

    });
  };

  get_cp_by_col(selectedCol: string): void {

    selectedCol = selectedCol.replace(' ',"_");
    selectedCol = selectedCol.replace('.', '');

    this.http
    .get(this.url.get_zip_by_col+this.id_state+'/'+this.city+'/'+selectedCol, {headers: this.headers})
    .subscribe((res: any) => {
      this.zip_code = res.cp;
    }, (error) => {

    });
  };

  general_info(generalInfo_: string): void{
    this.gen_info = JSON.parse(generalInfo_);
    localStorage.general_info = generalInfo_;

    this.change_step('3');
  };

// ------------------------ INICIAN LLAMADAS PARA / mbx-contact-info --------------------------------------------

  contact_data(contactInfo: string): void {
     localStorage.contact_info = contactInfo;
     this.step_3 = false;
     localStorage.location = 'compare'
     this.location = localStorage.location;
     this.contact_info = JSON.parse(contactInfo);
  };

// ------------------------ INICIAN LLAMADAS PARA / comparator-info  --------------------------------------------

  params_cot(paramsCot: string): void {

    this.progress = 0;
    this.insurance_data = [];

    this.params_quote = JSON.parse(paramsCot);
    this.http
    .post(this.url.get_services, this.params_quote, {headers: this.headers})
    .subscribe((res: any) => {

      this.percent_item = 100 / res.services.length;


      this.services_ = res;
      this.form_data_id = String(res.form_data_id);
      localStorage.quote_info = JSON.stringify(res);

      if(res.services.length) {

        this.insurance_length = res.services.length;


        for(let i in res.services) {
          let service_ = res.services[i];
          this.params_quote.service = service_;
          this.params_quote.form_data_id = res.form_data_id
          this.run_services(this.params_quote, service_);
        }
      }
    }, (error) => {

    });

  };

  run_services(params: any, service: string): void {
    // params = JSON.parse(params);
    // TODO: cambiar forma de pago para los multianuales, revisar multianual en el combo
    if(!service) {
      service = String(params.service);
    }

    if(params.recotization) {



    } else {

      if(params.index_item) {
        if(params.index_item == 0) {
          this.percent_item = 100 / params.total_items;
          this.insurance_length = params.total_items;
          this.progress = 0;
          this.insurance_data = [];
        }
      }

    }

    this.http
    .post(this.url.run_service+service, params, {headers : this.headers})
    .subscribe((res: any) => {

      if(params.recotization) {
        // console.log('req', res);
        this.new_quote = res;

        if(res.id) {
          localStorage.quote_selected = JSON.stringify(res);
        }

      } else {

        this.progress = this.progress + this.percent_item;
        this.insurance_count = this.insurance_count +1;

        res.loader = false;
        if(!res.error) {
          if(this.insurance_data.length) {

            let first_elem = this.insurance_data[0];

            for(let i in this.insurance_data) {

              let ins = this.insurance_data[i];
              if(ins.service.id == res.service.id) {
                this.insurance_data[i]  = res;
              }
            }
          } else {
            this.insurance_data.push(res);
          }
        } else {

          for(let i in this.insurance_data) {

              let ins = this.insurance_data[i];
              if(ins.service.name == res.error[0]) {
                res.service = ins.service;
                this.insurance_data[i] = res;
              }
            }
        }

        if(this.insurance_count == this.insurance_length) {
          this.loader = false;
          localStorage[params.cob+'_'+params.quoteFrecuency] = JSON.stringify(this.insurance_data)
        }

      }


    }, (error) => {
      console.log('error', error);
      this.insurance_count = this.insurance_count +1;
      if(this.insurance_count == this.insurance_length) {
        this.loader = false;
      }
    });

  }

    // RECOTIZAR
    new_car_model(params: any): void {
      // console.log('params', params);
      this.http
      .get(this.url.get_new_car_model+params.serviceId+'/'+params.brand+'/'+params.year)
      .subscribe((res: any) => {
        // console.log('get_newc_car_model', res);
        this.data_new_cars = {
          service: params.serviceId,
          data: res
        }
        // this.data_new_cars = res;
      }, (error) => {

      });
    };

    another_service(params: any):void {

      if(params.index_item) {
        if(params.index_item == 0) {
          this.percent_item = 100 / params.total_items;
          this.insurance_length = params.total_items;
          this.progress = 0;
          this.insurance_data = [];
        }
      }

      this.http
      .post(this.url.run_another_service + params.service, params, { headers: this.headers })
      .subscribe((res: any) => {
        res.loader = false;
        if(params.changePack) {
          this.progress = this.progress + this.percent_item;
          this.insurance_count = this.insurance_count +1;
          this.insurance_data.push(res);

          if(this.insurance_count == this.insurance_length) {
            this.loader = false;
            localStorage[params.cob+'_'+params.quoteFrecuency] = JSON.stringify(this.insurance_data)
          }

        } else {
          this.data_new_car = res;
        }

      }, (error) => {

      });

    };

    // GET PDF

    getPdf(pdfParams: any): void {
      pdfParams.organizacion = this.config.urlname
      // console.log('pdfParams', pdfParams);
      this.http
      .post(this.url.pdf, pdfParams, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log('PDF', res);
        // if(request.status === 200) {

            var file = new Blob([res], {type: 'application/pdf'});
            if(window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              // let content = $sce.trustAsResourceUrl(fileURL);
              // window.open(content);
              window.open(fileURL);
            }

          // } else {
          //   $rootScope.notify('Ha ocurrido un error con el pdf');
          // }
      }, (error) => {
        // console.log('error PDF', error.error.text);
        var file = new Blob([error.error.text], {type: 'application/pdf'});
            if(window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file);
            } else {
              var fileURL = URL.createObjectURL(file);
              // let content = $sce.trustAsResourceUrl(fileURL);
              // window.open(content);
              window.open(fileURL);
            }



      });
    }

    // button CONTINUAR
    select_quote(quote: any): void {
      // console.log('quote', quote);
      localStorage.quote_selected = JSON.stringify(quote);
      localStorage.location = 'quote_detail';
      this.location = localStorage.location;
    };


    // demo
    data_selected(message: string):void {
      localStorage.location = 'quote_detail';
      this.location = localStorage.location;
    }

// ------------------------ INICIAN LLAMADAS PARA / quote-detail     --------------------------------------------


  return_compare(location: string):void {
    this.location = location;
  }

  return_init(location: string):void {
    this.location = location;
  }

  save_info_quote(dataSave: any):void {

    let car_info     = dataSave[0],
        address_info = dataSave[1],
        params       = dataSave[2];

    // console.log('dataSave', dataSave);

    let quote              = JSON.parse(localStorage.quote_selected),
        paren_car_form_url = quote.parent_car_form;

    //

    this.http
    .patch(paren_car_form_url, car_info, {headers: this.headers})
    .subscribe((res: any) => {

      let client_info = res.user_info;
      let client_address = client_info.client_address[0];

      // console.log('client_info', client_info);

      let contact_ = {
        phone: params.phone,
        email: params.email
      };

      this.http
      .patch(client_info.url, contact_, {headers: this.headers})
      .subscribe((ress: any) => {
        console.log('ress', ress);
      }, (error) => {

      });

      this.http
      .patch(client_address.url, address_info, {headers: this.headers})
      .subscribe((req: any) => {

          if(this.config.policy_emit) {

            if(dataSave.emitir_poliza || this.config.policy_emit) {
              this.run_emission_service(params);
            } else {
              // ALERTA
              console.log('En seguida nos comunicaremos contigo');
              // localStorage.clear();
              // localStorage.location = 'step_1';
              // this.location = localStorage.location;
              // this.change_step('1');
            }


          } else {
            localStorage.clear();
            if(localStorage.location == 'admin_list') {

            } else {
              localStorage.location = 'step_0';
              this.location = localStorage.location;
              this.change_step('0');
            }
          }
        // if emision
      }, (err) => {

      });

    }, (error) => {

    });

  };


  run_emission_service (params: any):void {

    let quote_ = JSON.parse(localStorage.quote_selected);
    // console.log('headers', this.headers);

    // console.log('params', params);

    this.http
    .post(this.url.run_emission_service + quote_.service.id, params, {headers: this.headers})
    .subscribe((res: any) => {

      // aqui---------
      if(res.error) {
        res.service = {
          id: quote_.service.id
        }
      }

      this.emision_data = res;

      if(res['WS error']) {
        console.log('res emision', res['WS error']);
      } else {
        if(res.PDF) {

          window.open(res.PDF,'_blank');
          localStorage.clear();
          this.change_step('1');
          this.http
          .patch(quote_.url,
                {
                  emitido: true,
                  PDF: res.PDF
                },
                {
                  headers: this.headers
                })
          .subscribe((req: any) => {
            // console.log('POLIZA - EMITIDA');
            if(this.config.policy_emit) {
              this.status_emit = true;
            }
          }, (err) => {

          });

        } else if(res.poliza_pdf || res.recibos_pdf) {

          let pdf_poliza = res.poliza_pdf;
          let pdf_recibos = res.recibos_pdf;

          let contentType = "application/pdf";
          let folderpath = 'layouts/';
          let filename = "file_emision.pdf";

          this.http
          .patch(quote_.url, { emitido: true }, {headers: this.headers})
          .subscribe((req: any) => {
            // console.log('EMITIDO - OK');
            if(this.config.policy_emit) {
              this.status_emit = true;
            }
          });

          this.savebase64AsPDF(folderpath,filename,pdf_poliza,contentType);
          this.savebase64AsPDF(folderpath,filename,pdf_recibos,contentType);

          localStorage.clear();

        } else if(res.impresion) {
          let pdf_poliza = res.impresion;

          let contentType = "application/pdf";
          let folderpath = 'layouts/';
          let filename = "file_emision.pdf";

          this.http
          .patch(quote_.url, { emitido: true }, {headers: this.headers})
          .subscribe((req: any) => {

            if(this.config.policy_emit) {
              this.status_emit = true;
            }

          });

          this.savebase64AsPDF(folderpath,filename,pdf_poliza,contentType);

          // localStorage.clear();

        } else {

          if(res['WS error: ']) {
            // $rootScope.notify('error', request.data['WS error: ']);
          } else if (res.error) {
              // $rootScope.notify('error', request.data.error[2]);
          } else {

            if(res.indexOf('PDF') > -1){

              let base64_pdf = res;

              let contentType = "application/pdf";
              let folderpath = 'layouts/';
              let filename = "file_emision.pdf";

              this.http
              .patch(quote_.url, { emitido: true }, {headers: this.headers})
              .subscribe((req: any) => {

                if(this.config.policy_emit) {
                  this.status_emit = true;
                }
              });

              this.savebase64AsPDF(folderpath,filename,base64_pdf,contentType);

              // localStorage.clear();

            }
          }

        }


      }
    }, (error) => {

    });


  };

  b64toBlob(b64Data, contentType): void {

    contentType = contentType || '';
    let sliceSize = 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, {type: contentType});
    // return blob;
  };

  savebase64AsPDF(folderpath,filename,content,contentType): void {
     // Convert the base64 string in a Blob
      let DataBlob = this.b64toBlob(content,contentType);
      let blobUrl = URL.createObjectURL(DataBlob);

      // window.location = blobUrl;
      window.open(blobUrl,'_blank');
  };

// ------------------------ INICIAN LLAMADAS PARA / admin            --------------------------------------------

  // SEARCH ENGINE
  search_engine(param: any): void {

    this.http
    // .get(this.url.search+'?car_descr='+param, {headers: this.headers})
    .get(this.url.search, {
      headers: this.headers,
      // params: params_
      params: {
        cadena: param.data_
      }
    })
    .subscribe((res: any) => {
      // console.log('res', res);

      this.quotes_datasource = res.results;
      this.pagination = null;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };
    });
  }

  // PAGINATION
  get_quotes(params: string): void {

    // console.log('params', params);
    this.http
    .get(params, {headers: this.headers})
    .subscribe((res: any) => {
      console.log('res', res);
      this.quotes_datasource = res.results;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };
    });
  }

  getQuoteList(parUrl) {

    // console.log('parUrl', parUrl);

     if(!this.headers) {
       let headers = new HttpHeaders().set('Authorization','Token '+ sessionStorage['token']);
     }

     if(parUrl) {
       this.url_quotes = parUrl;
     } else {
       this.url_quotes = this.url.get_car_form;
     }

    this.http
    .get(this.url_quotes, { headers: this.headers })
    .subscribe((res: any) => {
      // console.log('car_form', res);
      this.quotes_datasource = res.results;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };

    }, (error) => {

    });
  };

  new_status_quote(params: string):void {
    console.log('new_status_quote - param', params);

    this.http
    .patch(params['url'], {status: params['status'] }, {headers: this.headers})
    .subscribe((res: any) => {
      // console.log('aaaa', res);
      for(let i in this.quotes_datasource) {
        var item = this.quotes_datasource[i];

        if(item.id == params['id']) {
          this.quotes_datasource[i] = res;
        }
      }

      // this.quotes_datasource = this.quotes_datasource;
    });
  }

  status_filter(status: any): void {

    if(status > 0) {
      var url__ = this.url.get_car_form_status+'?status='+status;
    } else {
      var url__ = this.url.get_car_form;
    }

    this.http
    .get(url__, { headers: this.headers })
    .subscribe((res: any) => {
      this.quotes_datasource = res.results
    }, (error) => {

    });

  };

  comments_by_quote(id_quote: any): void {

    this.http
    .get(this.url.quote_comment+'?quote='+String(id_quote), { headers: this.headers })
    .subscribe((res: any) => {
      // console.log('comments---', res);
      this.comments_quote = res;
    }, (error) => {

    });
  };

  new_comment(comm_body: any): void {

    this.http
    .post(this.url.quote_comment, comm_body, { headers: this.headers })
    .subscribe((res: any) => {
      this.comment_added = res;
    }, (error) => {

    });

  };

  more_comments(parUrl: string):void {
    this.http
    .get(parUrl, { headers: this.headers })
    .subscribe((res: any) => {
      this.comments_quote = res;
    }, (error) => {

    });
  }

// ------------------------ INICIAN LLAMADAS PARA / carga            --------------------------------------------

  commodity_added;
  coverage_added;

  filterByStatus(parameters: any):void {

    this.http
    .get(this.url.search_carga_quote,
    {
      params: parameters,
      headers: this.headers
    })
    .subscribe((res) => {

      this.quotes_datasource = res['results'];

      this.pagination = null;
      this.pagination = {
        count : res['count'],
        next  : res['next'],
        previous : res['previous']
      };
    });
  }

  search_specific_quote(param: string): void {
    // console.log('parametros', param);
    this.http
    .get(this.url.search_carga_quote, {
      params: { cadena: param },
      headers: this.headers
    })
    .subscribe((res: any) => {
      // console.log('res .... search_carga_quote ', res);
    });

  }

  save_new_commodity(params: any):void {
    console.log('save_new_commodity', params);
    this.http
    .post(this.url.commodities, params, {headers: this.headers})
    .subscribe((res: any)=> {
      this.commodity_added = res;
    });
  }

  save_new_coverage(params: any):void {
    console.log('params', params);
    this.http
    .post(this.url.commodities_package, params, { headers: this.headers })
    .subscribe((res: any) => {
      // console.log('paquete', res);
      this.coverage_added = res;
    });
  }


  get_countries_(params: string):void {

    this.get_agencias(null);
    this.get_commodities(null); // mercancias
    this.get_containers(); // contenedores - listado
    this.get_coverages(); // coverturas
    this.get_services(null);

    this.http
    .post(this.url.get_countries, null,{headers: this.headers})
    .subscribe((res: any) => {
      // console.log('paises', res);
      this.country_list = res;
    });

  };


  get_insurances_by_clients(params: any): void {
    // console.log('parmas', params);
    this.http
    .get(this.url.client_services, {
      params: {
        grupo: params.id
      },
      headers: this.headers
    })
    .subscribe((res: any) => {
      // console.log('!!!!.!!!!!!!!!!!!!!get_insurances_by_clients');
      this.insurances_by_user = res;

    });
  }

  patch_insurances(params: any) {

    let count = 0;
    let new_array = [];
    for(let i in params) {
      this.http
      .post(this.url.patch_perm, { id: params[i].id, is_active: params[i].is_active }, {headers: this.headers})
      .subscribe((res: any) => {
        count = count +1;

        new_array.push(res);

        if(count == params.length) {
          localStorage.original_insurances = JSON.stringify(new_array);
          this.create('success', 'Aseguradoras', 'El cambio se ha realizado con éxito.');
        }
      });
    }

  }

  get_services(param: any) {

    // console.log('get_services', param);
    let data = null;
    if(param) {
      data = {
        grupo: param.id
      }
    }

    this.http
    .get(this.url.services+'?ramo=3', {
      params: data ,
      headers: this.headers })
    .subscribe((res: any) => {
      this.services = res;
    });
  };

  spcify_rates(param) {
    this.http
    .post(this.url.specify_rates+param.product+'/'+ param.quotation + '/' + param.id, null, { headers: this.headers })
    .subscribe((res: any) => {
      // console.log(res);
      this.specify_rates_list = res.result.json;
    });
  };

  get_containers() {
    this.http
    .post(this.url.containers_list, null, {headers: this.headers})
    .subscribe((res: any) => {
      // console.log('containers', res);
      // this.containers_list = res.result.json;

      this.containers_list = [];

      // Validacion en caso de que la peticion regrese detalle
      if(res != 'Error al iniciar sesión en JAH WS intente nuevamente'){
          for(let i in res.result.json) {
            let item_type = res.result.json[i].type;

            item_type.replace(/PULGADAS/g, 'PIES');
            res.result.json[i].type = item_type;
            this.containers_list.push(res.result.json[i]);
          }
       }
    });
  };

  get_common_commodities(params: any):void {

    // console.log('params', params);
    this.http
    // .get(this.url.commodities, params, {headers: this.headers})
    .get(this.url.commodities, {
      params: params,
      headers : this.headers
    })
    .subscribe((res: any) => {
      // console.log('res... common commodities', res);
      this.commodity_list = res;
    });
  };

  get_commodities(param: any):void {
     this.http
    .post(this.url.commodity_list, null, {headers: this.headers})
    .subscribe((res: any) => {

      //console.log('--------------get_commodities res: ', res);


      // Validacion en caso de que la peticion regrese detalle
      if(res != 'Error al iniciar sesión en JAH WS intente nuevamente'){
          for(let i in res.result.json) {

            let item = res.result.json[i];

            switch(item.name) {
              case 'Mercancía General':
                item['name_'] = item.name;
                break;
              case 'Mercancía general':
                item['name_'] = item.name;
                break;
              case 'Grupo 1':
                item['name_'] = 'Vehículos';
                break;
              case 'Grupo 2':
                item['name_'] = 'Refrigerados';
                break;
              case 'Grupo 3':
                item['name_'] = 'Electrónicos';
                break;
              case 'Grupo 4':
                item['name_'] = 'Químicos';
                break;
              case 'Grupo 5':
                item['name_'] = 'Rompibles';
                break;
              default:
                item['name_'] = item.name;
                break;
            }
          }
          this.commodity_list = {
            name : 'jah',
            data: res.result.json
          };
        }
    });
  }

  get_coverages() {
    this.http
    .post(this.url.coverages_list, null, {headers: this.headers})
    .subscribe((res: any)  => {
      this.coverages_list = res.result.json;
    });

  }

  // add client
  add_client() {

    this.http
    .post(this.url.get_countries, null,{headers: this.headers})
    .subscribe((res: any) => {
      this.country_list = res.result.json;
    });

    this.show_form_client = true;
    this.location = 'add_clients';
    localStorage.location = 'add_clients';
  }

  edit_pol_ind(params: any):void {

    // console.log(params)
    params.urlname = this.config.urlname;
    /* Llamada para póliza individual*/
      this.http
      .post(this.url.create_ind_pol, params, { headers: this.headers })
      .subscribe((resInd: any) => {
        this.headers['Content-Type'] =  'multipart/form-data';
        this.http
        .patch(resInd.url, params.file_, { headers: this.headers })
        .subscribe((resInd: any) => {
        });
        this.create('success', 'Éxito!', 'Póliza individual creada satisfactoriamente.');
      }, (err: any) => {
        console.log('error', err);
        this.create('error', 'Error', err.error.error);
      });

  }

  save_client(params: any):void {

    // add urlname
    params.urlname = this.config.urlname;
    // console.log('params', params)
    this.http
    .post(this.url.create_group, params, { headers: this.headers })
    .subscribe((res: any) => {
      /* Llamada para póliza individual*/
      params.contratante = res.url;
      params.contractor_id = res.id;
      this.http
      .post(this.url.create_ind_pol, params, { headers: this.headers })
      .subscribe((resInd: any) => {
        // console.log('res1', resInd)
        if(params.individual){

          this.headers['Content-Type'] =  'multipart/form-data';
          this.http
          .patch(resInd.url, params.file_, { headers: this.headers })
          .subscribe((resInd: any) => {
            // console.log('resInd2', resInd);
          });

          this.create('success', 'Éxito!', 'Póliza individual creada satisfactoriamente.');
        }
      }, (err: any) => {
        console.log('error', err);
        this.create('error', 'Error', err.error.error);
      });
      this.client_info = res;
      this.return_to_ ='clear_user';
      this.create('success', 'Éxito!', 'Registro creado satisfactoriamente.');
    }, (err: any) => {
      console.log('error', err);
      this.create('error', 'Error', err.error.error);
    });

  }

  pdf_test;


  pdf_carga(params: any):void {

    let datos;

    if(params) {

      datos = {
        organizacion: this.config.urlname, // ulrname
        compania: params.service,
        carga_quote: params.id
      }

    } else {

      datos = {
        organizacion: this.config.urlname, // ulrname
        compania: 6,
        carga_quote: 259
      }

    }
     this.http
    .post(this.url.pdf_carga, datos,{headers: this.headers})
    .subscribe((res:any) => {
      this.create('success', 'Documento anexado con éxito.', null);
      window.open(res.url);
    }, (error) => {

      let data = error.error.text;
      var buffer = new Buffer(data);
      var string = buffer.toString('base64');

      var pdfInBase64 = window.atob(string);
      var file = new Blob([pdfInBase64], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      // console.log('-paramsss',params)
      if(params.status == 3 && (params.aseguradora_name == 'GNP MXN' || params.aseguradora_name == 'GNP USD'
      || params.aseguradora_name=='CHUBB USD' || params.aseguradora_name=='CHUBB MXN' )){
        if (params.contratante_info.policy_file != 'None') {
           window.open(this.url.media +params.contratante_info.policy_file);
        }else{
          // this.http
          // .post(this.url.pdf_gnp, datos,{headers: this.headers})
          // .subscribe((res) => {

          // },(error) => {
          //   let data2 = error.error.text;
          //   var buffer2 = new Buffer(data2);
          //   var string2 = buffer2.toString('base64');
          //   var pdfInBase642 = window.atob(string2);
          //   var file2 = new Blob([pdfInBase642], { type: 'application/pdf' });
          //   var fileURL2 = URL.createObjectURL(file2);
          //   window.open(fileURL2);
          // });
          //let ruta = '../assets/files/Anexo GNP 302010665 V.0.1.pdf';
          //window.open(ruta);

        }
      }

      //descargar pdf
      // const linkSource = 'data:application/pdf;base64,' + string;
      // const downloadLink = document.createElement("a");
      // const fileName = "hoja_de_trabajo.pdf";

      // downloadLink.href = linkSource;
      // downloadLink.download = fileName;
      // downloadLink.click();


    });

  }


  get_group_list () {

    let params = {
      urlname: this.config.urlname
    };

    this.http
    // .get(this.url.get_groups, { urlname: this.config.urlname }, {headers, this.headers})
    .get(this.url.get_groups, {
      params: {
        urlname: this.config.urlname
      },
      headers : this.headers
    })
    .subscribe((res: any) => {
      // console.log('lista de grupos', res);
      // checar paginación.
      this.group_list = res.results;
    });

  };

  new_user_client;
  save_user(params: any):void {

    params.urlname = this.config.urlname;

    this.http
    .post(this.url.save_client_user, params, {headers: this.headers})
    .subscribe((res: any) => {
      // console.log();
      this.create('success', 'Usuario creado con éxito.', null);
      this.new_user_client = res;

    });
  }

  new_user_admin;
  save_user_admin(params: any):void {

    params.urlname = this.config.urlname;
    if (params.url==undefined || params.url==undefined ){
      this.http
      .post(this.url.save_admin_user, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        this.create('success', 'Usuario creado con éxito.', null);
        this.new_user_admin = res;
        this.get_admins('');

      }, ({error}) => {
         this.create('error', error.error , null);
      });
    } else if (params.url){
      this.http
      .patch(params.url.replace('users', 'users-admin')+'?urlname='+this.config.urlname, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        this.create('success', 'Usuario actualizado', null);
        this.new_user_admin = res;
        this.get_admins('');

      }, (error) => {
        let error_message = '';
        for (let key in error.error){
          error_message += error.error[key][0]
          }
        console.log('error', error_message);
         this.create('error', error_message, null);
      });
    }
  }

  get_exchange_rate() {
    this.http
    .get(this.url.exchange_rate)
    .subscribe((res: any) => {
      this.exchange_rite = res;
    });
  }


   // SEARCH ENGINE CONTRACTORS
  // search_contractors(param: any): void {

  //   // console.log('param', param);

  //   this.http
  //   // .get(this.url.search+'?car_descr='+param, {headers: this.headers})
  //   .get(this.url.contractors_filter, {
  //     headers: this.headers,
  //     params: {
  //       cadena: param
  //     }
  //   })
  //   .subscribe((res: any) => {
  //     console.log('res', res);

  //     this.contractors_datasource = res.results;
  //     // this.pagination = null;
  //     // this.pagination = {
  //     //   count : res.count,
  //     //   next  : res.next,
  //     //   previous : res.previous
  //     // };
  //   });
  // };

  get_insured_list(params: any):void {
    // this.url.insured_filter
    // this.http
    // .post(this.url.beneficiary_list,
    //   {
    //       urlname: this.config.urlname
    //   }, {headers: this.headers})
    // .subscribe((res: any) => {
    //   console.log('list_beneficiarios', res);
    //   this.insured_list = res.result.json;
    // } );

    let parameters = {
      cadena: params.cadena
    };

    if(this.admin) {
      parameters['grupo'] = params.grupo;
    }


    // let options_ = new reqOptions({params: parameters, headers: this.headers});
    let options_ = {params: parameters, headers: this.headers};

    this.http
    .get(this.url.insured_filter, options_)
    .subscribe((res: any) => {
      this.insured_list = res.results;
    });

  }

  get_quotes_(params: any): void {
    if(!params.fecha_inicio) {
      params.fecha_inicio = 0
    } else {
      params.fecha_inicio = new Date(new Date(params.fecha_inicio).setHours(0,0,0));
    }

    if(!params.fecha_fin) {
      params.fecha_fin = 0
    } else {
      params.fecha_fin = new Date(new Date(params.fecha_fin).setHours(23,59,59));
    }
    this.http
    .get(this.url.filter_carga_quotes, {
      params: params,
      headers: this.headers
    })
    .subscribe((res: any) => {
      this.result_carga_list = res.results;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };

    });

  }

  save_insured(param: any):void {

    param.urlname = this.config.urlname;

    this.http
    .post(this.url.insured, param, { headers: this.headers })
    .subscribe((res: any) => {
      // console.log('asegurados', res);
      this.insured_selected = res;
      localStorage.insured_selected = JSON.stringify(res);
      this.create('success', '¡Éxito!', 'Usuario creado');


    }, (e) => {
      if(e.error.email) {
        this.create('error', '¡Error!', e.error.email);
      } else {
        console.log('error: ', e.error);
        this.create('error', '¡Error!', 'No se pudo crear el asegurado: ' + e.error);
      }
    });
  };

  edit_result;
  edit_insured(param: any):void {
    // console.log('EDIT', param);
    var url_ = param.url;
    delete param.url;
    delete param.id;
    // console.log('utl_', url_);
    this.http
    .patch(url_, param, {headers: this.headers})
    .subscribe((res)=> {
      this.edit_result = res;
      this.edit_result.index = param.index;
      // console.log('res - patch', res)
      this.create('success', '¡Éxito!', 'Los datos se han guardado');
    });

  }


  delete_result;
  delete_insured(params: any):void {
    this.http
    .delete(params.url, {headers: this.headers})
    .subscribe((res) => {
      this.delete_result = params;
    });
  }


  get_asegurados_(params: any):void {
    this.http
    .get(this.url.insured_filter,
          { params: { cadena : "", grupo: params},
            headers: this.headers })
    .subscribe((res: any) => {
      this.all_asegurados_data = res.results;
    });
  }

  add_contractor(param: any):void {
    // console.log('add_contractor - params', param);

    this.http
    .post(this.url.add_contractor, param, { headers: this.headers })
    .subscribe((res: any) => {
      // console.log('add_contractor', res);
      this.create('success', 'Contratante creado con éxito.', null);
      this.contractor_added = res;
    });
  };



  save_quote(params: any):void {
    if(!params.importacion) {
      params.importacion_desde = null;
      params.importacion_hasta = null;

    }

    if(!params.exportacion) {
      params.exportacion_desde = null;
      params.exportacion_hasta = null;

    }

    this.http
    .post(this.url.carga_quote, params, { headers: this.headers })
    .subscribe((res: any) => {
      this.create('success', 'Información guardada exitosamente', null);
      this.response_quote = res;
    },
     (error) => {
       console.log('error', error);
        this.create('error', 'Lo sentimos ha ocurrido un error, favor de intentar nuevamente.', null);
     });

  };

  get_full_carga(): void {

    this.http
    .get(this.url.contratante_carga_full, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_carga_list = res.results;

      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };

    });

  }

  // PAGINATION
  get_contractors(params: string): void {

    // console.log('params', params);
    this.http
    .get(params, {headers: this.headers})
    .subscribe((res: any) => {
      // console.log('res', res);
      this.result_carga_list = res.results;
      this.pagination = {
        count : res.count,
        next  : res.next,
        previous : res.previous
      };
    });
  }

  // PATCH
  patch_data(data: any): void {

    this.http
    .patch(data.url, data.params, { headers: this.headers })
    .subscribe((res: any) => {
      console.log('res - parch', res);
      this.create('success', 'ESTAUS', 'Se ha cambiado exitosamente.');
    });
  }

  patchInfoContractor(data: any): void {
    // console.log('adasd');
    this.http
    .patch(data.url, data, { headers: this.headers })
    .subscribe((res)=> {
      // console.log('res');
      this.create('success', '¡Éxito!', 'Los cambios se han guardado');
      this.return_to_ ='contractor_list';
    });
  }

  save_beneficiary(data: any):void {
    console.log('save_beneficiary', data);
    this.http
    .post(this.url.add_beneficiary, data, { headers: this.headers })
    .subscribe((res: any) => {
      console.log('res', res);
      this.create('success', 'Creación', 'Beneficiario creado con éxito.');
    });
  }


  get_rate_exchange(params: string): void {

    //console.log('parama', params);

    this.http
    .get(this.url.exchange_rate, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_rate_exchange = res;

    });

  }

  rates_changed;

  patch_coverages(params: any) {

    for(let i in params) {

      let item = params[i];

      for (let j in item.paquete_mercancia) {

        let coverages = item.paquete_mercancia[j];
        let tarifa = (coverages.tarifa).replace('%', '');
        let prima_minima = (coverages.prima_minima).replace('%', '');
        let prima_adquisicion = coverages.prima_adquisicion //().replace('%', '');
        let tasa_venta = (coverages.tasa_venta).replace('%', '');
        let is_active_tarifa = coverages.is_active_tarifa
        let is_active_tasa_venta = coverages.is_active_tasa_venta

        let datas = {
            tarifa: tarifa,
            prima_minima: prima_minima,
            is_active:coverages.is_active,
            moneda:coverages.moneda,
            prima_adquisicion:prima_adquisicion,
            tasa_venta:tasa_venta,
            is_active_tarifa:is_active_tarifa,
            is_active_tasa_venta:is_active_tasa_venta,
        }

        this.http
        .patch(coverages.url, datas, {headers: this.headers})
        .subscribe((res: any) => {

          if(parseInt(i) == params.length -1 && parseInt(j) == item.paquete_mercancia.length-1) {
            // this.create('success', '¡Éxito!', 'Las tarifas se han guardado exitosamente.');
            this.rates_changed = true;
            // this.return_to_ ='contractor_list';
          }
        });
      }
    }
  }
  /*
  get_report_client(params){
    // if(param){
    //   this.location = "step_1";
    //   localStorage['edit'] = JSON.stringify(param);

    // }
    this.http
    .post(this.url.report_client,params, {
      params: params,
      headers: {'Authorization': 'Token ' + sessionStorage['token'],
                'Content-Type': "application/json"},
      responseType : 'arraybuffer'
    })
    .subscribe((res: any) => {
      let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, 'Reporte-'+(Math.random() + 1).toString(36).substring(7)+'.xls');
      this.quotes_datasource = res.results;
      this.result_report_client= res.results;

    }, (error) => {
      console.log('get report', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error al obtener el reporte');
    });
  }
  */
  get_report_account_statements(params){
    this.http
    .post(this.url.report_account_statements,params, {
      params: params,
      headers: {'Authorization': 'Token ' + sessionStorage['token'],
                'Content-Type': "application/json"},
      responseType : 'arraybuffer'
    })
    .subscribe((res: any) => {
      let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, 'Reporte-AS-'+(Math.random() + 1).toString(36).substring(7)+'.xls');
      this.quotes_datasource = res.results;
      this.result_report_client= res.results;

    }, (error) => {
      console.log('get report', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error al obtener el reporte');
    });
  }
  get_report_client_commissions(params){
    this.http
    .post(this.url.report_client_commissions,params, {
      params: params,
      headers: {'Authorization': 'Token ' + sessionStorage['token'],
                'Content-Type': "application/json"},
      responseType : 'arraybuffer'
    })
    .subscribe((res: any) => {
      let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, 'Reporte-CC-'+(Math.random() + 1).toString(36).substring(7)+'.xls');
      this.quotes_datasource = res.results;
      this.result_report_client= res.results;

    }, (error) => {
      console.log('get report', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error al obtener el reporte');
    });
  }
  get_report_adviser_commissions(params){
    this.http
    .post(this.url.report_adviser_commissions,params, {
      params: params,
      headers: {'Authorization': 'Token ' + sessionStorage['token'],
                'Content-Type': "application/json"},
      responseType : 'arraybuffer'
    })
    .subscribe((res: any) => {
      let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, 'Reporte-AC-'+(Math.random() + 1).toString(36).substring(7)+'.xls');
      this.quotes_datasource = res.results;
      this.result_report_client= res.results;

    }, (error) => {
      console.log('get report', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error al obtener el reporte');
    });
  }
  edit_quote(param){
    // if(param){
    //   this.location = "step_1";
    //   localStorage['edit'] = JSON.stringify(param);
    // }
    this.http
    .post(this.url.edit_quote, param, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_update_quote = res;
    }, (error) => {
      console.log('error-save-quote', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
    });
  }

  doble_quote(params){
    params['service'] = params['compania'].id;

    this.http
    .post(this.url.carga_quote, params, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_certificate = res;

      localStorage['quote_saved'] = JSON.stringify(res);
      this.create('success', '¡Éxito!', 'La cotización se guardado exitosamente.');

      this.pdf_carga(res);

    }, (error) => {
      console.log('error-save-quote', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');

    });
  }

  save_carga_quotes(params: any): void {
    let files = params['document_file']
    params['service'] = params['compania'].id;
    params['document_file'] = null;
    this.headers['Content-Type'] = 'multipart/form-data';
    this.http
    .post(this.url.carga_quote, params, { headers: this.headers })
    .subscribe((res: any) => {
      if(params.quote_type == 2){
        localStorage['quote_saved'] = JSON.stringify(res);
        this.headers['Content-Type'] = 'multipart/form-data';
        var total:number = res.cargaquotefile_cargaquote.length;
        var proccesed:number = 0;
        if(total>0){
          const notification =  this._notifications.create('Espere', 'Se estan cargando los archivos espere un momento', 'info')

          for(let n  in res.cargaquotefile_cargaquote){
            let doc= res.cargaquotefile_cargaquote[n]

            /* -------- CAMBIO DE JQUERY A ANGULAR ----------- */

            // var settings = {
            //   "async": true,
            //   "crossDomain": true,
            //   "url": this.url.carga_quote_file+doc.id+'/',
            //   "method": "PATCH",
            //   beforeSend: function(request) {
            //    request.setRequestHeader("Authorization", 'Token ' + sessionStorage['token']); },
            //   "processData": false,
            //   "contentType": false,
            //   "mimeType": "multipart/form-data",
            //   "data": files[doc.document]
            // }

            /* ------- CAMBIO DE JQUERY A ANGULAR ---------- */

            var this_par=this;

            // Prueba de cambio de jquery a angular
            let archivoPDF = files[doc.document];
            let url = this.url.carga_quote_file + doc.id + '/';

            // Prueba de cambio de jquery a angular -> patch de documento
            this.http.patch(url, archivoPDF, { headers: this.headers }).subscribe((response: any) => {
              this.result_file = response;
              proccesed++;
              if (proccesed == total) {
                this_par._notifications.remove(notification.id);
                this_par.create('success', '¡Éxito!', 'La cotización se ha guardado exitosamente.');
                if (res.total != '0.00' && res.subtotal != '0.00') {
                  this_par.pdf_carga(res);
                }
                this_par.result_certificate = res;
              }
            }, (error) => {
              console.log('error-update-document-file', error);
              this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error al cargar el archivo.');
            });

            /* ------ CAMBIO DE JQUERY A ANGULAR --------- */

            // $.ajax(settings).done(function (response) {

            //   console.log(response);
            //   proccesed += 1;
            //   this_par.create('success', '¡Éxito!', proccesed.toString()+'/'+total.toString()+' Se ha cargado el archivo para el documento:'+doc.document);

            //   if(proccesed==total){
            //     this_par._notifications.remove(notification.id);
            //     this_par.create('success', '¡Éxito!', 'La cotización se guardado exitosamente.');
            //     if(res.total != '0.00' && res.subtotal != '0.00'){
            //       this_par.pdf_carga(res);
            //     }
            //     this_par.result_certificate = res;
            //   }
            // });

            /* ------- CAMBIO DE JQUERY A ANGULAR --------- */

            /*.error(function (response) {
              console.log("Error al actualizar ");
              this_par.create('error', '¡Error!','Ha ocurrido un error al cargar el archivo para el documento:'+doc.document);
              if(+n==(total-1)){
                this_par._notifications.remove(notification.id);
                this_par.create('success', '¡Éxito!', 'La cotización se guardado exitosamente.');
                if(res.total != '0.00' && res.subtotal != '0.00'){
                  this_par.pdf_carga(res);
                }
                this.result_certificate = res;
              }
            });*/


          }
        } else {
          this.create('success', '¡Éxito!', 'La cotización se guardado exitosamente.');
          if(res.total != '0.00' && res.subtotal != '0.00'){
            this.pdf_carga(res);
          }
          this.result_certificate = res;
        }
      }else{
        if(!params.quote_type || params.quote_type == 1 ){
          localStorage['quote_saved'] = JSON.stringify(res);
          this.create('success', '¡Éxito!', 'La cotización se guardado exitosamente.');
          if(res.total != '0.00' && res.subtotal != '0.00'){
            this.pdf_carga(res);
            this.result_certificate = res;
          }
        }
      }

      // // console.log('carga-quotes', res);
      // localStorage['quote_saved'] = JSON.stringify(res);
      // this.create('success', '¡Éxito!', 'La cotización se guardado exitosamente.');
      // if(res.total != '0.00' && res.subtotal != '0.00'){
      //   this.pdf_carga(res);
      // }

    }, (error) => {
      console.log('error-save-quote', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');

    });

  };

  emition_req : any;

  emitir_quotes(params: any): void {
    // if(params['facturacion']) {
    // } else {
    //   params['facturacion'] = false;
    // }

    let quote_saved = '';
    // pruebas para salir del modal
    if(localStorage['quote_saved']) {
      quote_saved = JSON.parse(localStorage['quote_saved']);
    }

    this.create('success', '¡Solicitud enviada!', 'Este proceso puede tardar unos minutos, por favor espere.');

    let url_emit = '';
    let params_ = {};
    // console.log(params.insurance);
    if(params.insurance == 'JAH') {

      url_emit = this.url.emitir_jah+params.id;
      // console.log('url_emit - JAH', url_emit);

    } else if(params.insurance == 'HDI_') {
      url_emit = this.url.send_email_carga;
    }  else if(params.insurance =='GNP MXN' || params.insurance=='GNP USD' || params.insurance=='CHUBB USD'
    || params.insurance=='CHUBB MXN') {
       // hacer el patch
    }

    if(params.params) {
      params_ = params.params

      params_['emails_contacto'] = [
        'laura.flores@grupoesscalo.com.mx',
        'claudia.zuñiga@grupoesscalo.com.mx',
        'sergio.ramirez@grupoesscalo.com.mx'
      ]

    } else {
      params_ = null;
    }

    if(params.insurance == 'GNP MXN' || params.insurance=='GNP USD' || params.insurance=='CHUBB USD' || params.insurance=='CHUBB MXN' || params.insurance == 'HDI'
    || params.insurance == 'CHUBB GLOBAL' || params.insurance == 'CHUBB INTERNACIONAL') {
       // Aqui tenemos que parchar la nueva fecha con cualquiera de las aseguradoras
       if(params.params.startDate){
        this.data_emitir = {
          status: 3,
          fecha_inicio: new Date(params.params.startDate),
          fecha_fin: new Date(params.params.endDate)
        };
       }else{
        this.data_emitir = {
          status: 3
        };
       }
       let id_quote;

       if (params.es_detalle) {
        id_quote = params.id;
       } else {
         if (quote_saved){
           id_quote = quote_saved['id']
         }else if (params) {
           id_quote = params.id
         }else{
            if (params.params){
               id_quote = params.params.carga_quote
            }else{
              id_quote = params.id
            }
         }
       }

      this.http
      // .patch(this.url.carga_quote + quote_saved['id'], this.data_emitir, { headers: this.headers })
      .patch(this.url.carga_quote + id_quote, this.data_emitir, { headers: this.headers })
      .subscribe((q_: any) => {
        let data = {
          service: params.insuranceId,
          id: q_.id,
          contratante_info: q_.contratante_info,
          status: q_.status,
          aseguradora_name: params.insurance ? params.insurance : q_.aseguradora_name
        }
        this.emition_req = q_;
        this.pdf_carga(data);

        if(params.facturacion || params_['facturacion']) {

            params_['facturacion'] = true;

            if(!params_['phone']) {
              params_['phone'] = '';
            }

            params_['jah_url'] = '';
          this.http
            .post(this.url.send_email_carga, params_, { headers: this.headers })
            .subscribe((res)=> {
              console.log('send_email_carga', res);
            });
        }
        if (q_.contratante_info.policy_file != 'None') {
          console.log('------file----',q_.contratante_info.policy_file)
        }else{
          console.log('-------------------fileeeee',q_.contratante_info)
          // window.open('../../../assets/files/Anexo GNP 302010665 V.0.1.pdf', '_blank');
        }
        this.create('success', '¡Éxito!', 'La cotización se ha emitido exitosamente.');

        // esperar 5 segundos antes de realizar la recarga de la pagina
        setTimeout(() => {
          location.reload();
        }, 5000);
      });
    } else {

      // console.log('url_emit', url_emit);
      // console.log('params', params_);

      // return;
      // params_ = {
      //   service: params.insurance
      // }

      // console.log('params_', params_);
      if(params.insurance == 'HDI_') {
        if(!params_['phone']) {
          params_['phone'] = '';
        }

      }

      this.http
      .post(url_emit, params_, { headers: this.headers })
      .subscribe((res: any) => {
        this.emition_req = res;
        if(params.insurance == 'JAH') {

          if(res.response_jah.result.code !== -11 && res.response_jah.result.code !== -1) {

            if(params.facturacion) {
              // console.log('facturacion OK -----------_ZZZZZZZ');

              // params_['phone'] = '';
              // params_['email'] = '';
              // params_['facturacion'] = true;
              // params_['jah_url'] = res.response_jah.result.path;
              params_ = {
                phone: '',
                email: '',
                facturacion: true,
                jah_url : res.response_jah.result.path,
                service: 'jah',
                emails_contacto : [],
                carga_quote: quote_saved['id']
              }

              // console.log('params_', params_);

              this.http
                .post(this.url.send_email_carga, params_, { headers: this.headers })
                .subscribe((res)=> {
                  console.log('send_email_carga', res);
                });


            }
            // else {
            //   params_['facturacion'] = false;
            // }


            this.result_emission = res.response_jah.result;



            this.http
            .patch(this.url.carga_quote+quote_saved['id'], {status: 3}, { headers: this.headers })
            .subscribe((q_) => {
              // console.log('status emitida');

            });
            // window.open(res.response_jah.result.path, '_blank');
            this.create('success', '¡Éxito!', 'La cotización se ha emitido exitosamente.');

            // esperar 5 segundos antes de realizar la recarga de la pagina
            setTimeout(() => {
              location.reload();
            }, 5000);

          } else {
            if(res.response_jah){
              this.create('error', '¡Error!', res.response_jah.result.message);

            } else {
              this.create('error', '¡Error!', 'La emision ha sido denegada.');
          }
          }
        }  else if( params.insurance == 'HDI'){

          // cambiar status a la cotización por 3 (emitida)
          // this.http
          // .patch(quote_saved['url'], {status: 3}, { headers: this.headers })
          // .subscribe((q_) => {
          //   console.log('status emitida');

          // });

          if(params.facturacion) {
            params_['facturacion'] = true;
          } else {
            params_['facturacion'] = false;
          }

          params_['jah_url'] = '';

          this.http
            .post(this.url.send_email_carga, params_, { headers: this.headers })
            .subscribe((res)=> {
              // console.log('send_email_carga', res);
            });

          this.create('success', '¡Éxito!', 'El correo se ha enviado.');

        }


      }, (error) => {
        console.log('error-save-quote', error);
        this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
      });

    }

  }
  create_factura(param){
    this.http
    .post(this.url.factura, param, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_factura = res;
    }, (error) => {
      console.log('error-create-factura', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
    });
  };
  edit_factura(param){
    this.http.patch(param.url, param, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_factura = res;
    }, (error) => {
      console.log('error-update-factura', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
    });
  };

  create_comision(param){
    this.http
    .post(this.url.comision, param, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_comision = res;
    }, (error) => {
      console.log('error-create-comision', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
    });
  };
  edit_comision(param){
    this.http.patch(param.url, param, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_comision = res;
    }, (error) => {
      console.log('error-update-comision', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
    });
  };

  save_complemento(params: any):void {
    //console.log("save_complemento params", params)
    //params.urlname = this.config.urlname;
    if (params.url==undefined || params.url==undefined ){
      this.http.post(this.url.complemento, params, {headers: this.headers})
      .subscribe((res: any) => {
        //console.log("respuesta post complemento", res);
        // this.create('success', 'Agencia creada con éxito.', null);
        //this.new_agencia = res;
        //this.get_agencias('');
      }, ({error}) => {
        console.log('error-post-complemento', error);
        this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
      });
    } else if (params.url){
      this.http
      .patch(params.url+'?urlname='+this.config.urlname, params, {headers: this.headers})
      .subscribe((res: any) => {
        // console.log();
        // this.create('success', 'Agencia actualizado', null);
        //this.new_agencia = res;
        //this.get_agencias('');
      }, (error) => {
        console.log('error-patch-complemento', error);
        this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error');
      });
    }
  }
  result_file;
  edit_document_file(param){
    var id = param.get('id');
    let url = this.url.carga_quote_file + id +"/";
    this.http.patch(url, param, { headers: this.headers })
    .subscribe((res: any) => {
      this.result_file = res;
    }, (error) => {
      console.log('error-update-document-file', error);
      this.create('error', '¡Lo sentimos!', 'Ha ocurrido un error al cargar el archivo.');
    });
  };
};



// WEBPACK FOOTER //
// ./src/app/app.component.ts